<template>
    <v-card v-resize="onResize" style="position: relative; width: 100%;height:100%">


        <v-snackbar top v-model="snackbar" :color="snackbarColor" timeout="2000">{{snackbarInfo}}</v-snackbar>
        <div v-if="$store.state.user.dialogTip"  @scroll.stop.prevent class="mongolia" style="z-index: 97;" ></div>
        <v-card v-if="$store.state.user.dialogTip" style="position: absolute; width: 500px; height: 300px; z-index: 98;"  :style="{'margin-left':(windowSize.x-500)/2+'px','margin-top':(((windowSize.y-300)/2)+scrollTop)+'px',}">
            <v-card-title></v-card-title>
            <v-card-text style="background-color: white;border:0px solid #d8d8d8;margin-left: 20px;width: 460px  ">
                <p style="font-size: 22px;font-family:'Microsoft YaHei';font-weight:bolder;color: #86AFF8;margin-left: 185px;margin-top: 10px;margin-bottom: 10px; ">声明</p>
                <p style="font-size: 16px;line-height:30px;">
                    长光卫星统一交付平台产品数据保存时长为45天，45天后数据将彻底删除，无法恢复，请您及时下载数据，我们将在订单完成时、剩余15天时、剩余1天时为您发送提醒邮件。特此声明！
                </p>
            </v-card-text>
            <v-card-actions style="border:0px solid #d8d8d8;margin-top: -40px;">
                <v-spacer></v-spacer>
                <v-checkbox
                        label="已阅读 不再提示"
                        v-model="tipNotAgainShow"
                        style=""
                        color="#86AFF8"
                >
                </v-checkbox>
                <div style="width: 222px;"></div>
                <v-btn   style="background-color:#86AFF8;color: white;margin-right: 40px; width: 80px;height: 30px;cursor: pointer;" @click="dialogTipClose()">关闭</v-btn>
            </v-card-actions>
        </v-card>

        <!-- 首页 -->
        <Sidebar></Sidebar>
        <div class="mainArea">


            <div class="navigation">



                <div style="height: 100%;display: flex;margin-left: 17px;">
                    <img src="../assets/logo.png" style="width: 32px;height: 32px;margin-top: 8px;">
                    <div style="font-size: 20px;color: #E9ECEC;margin-top: 10px;margin-left: 17px;">长光卫星统一交付平台</div>
                    <a href="http://pan.charmingglobe.com/old/order" target="_blank"  style="font-size: 14px;color: #329999;margin-top: 17px;margin-left: 28px;cursor: pointer;text-decoration: underline;">切换至旧版</a>
                </div>
                <v-spacer></v-spacer>


                <!--大客户下载规范-->
                <div v-if="$store.state.user.isBigCustomer" style="margin-top: 0px;float:left;text-align:center;display:flex;justify-content:left;align-items:center;">
                  <a href="/static/大客户交付使用指南.pdf" target="_blank" style="margin-left: 10px;margin-top: 2px;font-size: 14px">
                    大客户交付使用指南
                  </a>
                </div>
                <!--大文件下载规范-->
                <div v-if="!$store.state.user.isBigCustomer" style="margin-top: 0px;float:left;text-align:center;display:flex;justify-content:left;align-items:center;">
                  <a href="/static/大数据量压缩包下载解压说明20230822.pdf" target="_blank" style="margin-left: 10px;margin-top: 2px;font-size: 14px">
                    大数据量压缩包下载解压说明
                  </a>
                </div>
                <!--  大客户  -->
                <div v-if="$store.state.user.isBigCustomer">
                    <v-btn dark text style="height: 49px;" @mouseenter="bigCustomerMenu=true" @mouseleave="bigCustomerMenu=false">
                        <img src="../assets/大账户.png" style="width: 20px;height: 20px;margin: 0px 4px;">
                        企业大客户专属
                    </v-btn>
                </div>
                <div>
                    <v-menu v-if="$store.state.user.logined" open-on-hover bottom offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" dark small text class="text-none">
                                {{$store.state.user.userId}}
                                <img src="../assets/三角下标.png" style="width: 12px;height: 12px;margin-left: 5px;">
                            </v-btn>
                        </template>
                        <v-list dense width="100" class="modify-list">
                            <v-list-item dense tile @click="$store.state.changePassword=true;$store.state.persistent = false" style="font-size: 14px;justify-content: center;">修改密码</v-list-item>
                            <v-list-item dense @click="logout()" style="font-size: 14px;justify-content: center;">退出登录</v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
            <div class="globeArea">
                <cesium-view></cesium-view>
                <!--  右下角经纬度坐标  -->
                <div class="bottom-bar">
                    <p id="mainArea-globe-info-camera" style="display: block;">Camera: <span id="heightStr">3,000.00 km</span></p>&nbsp;&nbsp;
                    <p id="mainArea-globe-info-lat" style="display: block;">Lat: <span id="latitudeStr">33°0′22″N</span></p>&nbsp;&nbsp;
                    <p id="mainArea-globe-info-lon" style="display: block;">Lon: <span id="longitudeStr">136°2′14″E</span></p>&nbsp;&nbsp;
                    <p>| ©<span onclick="window.open('http://www.charmingglobe.com/')" style="cursor: pointer; color: rgb(98,136,216);">CGSTL</span></p>
                    <p>| ©<span onclick="window.open('https://mall.charmingglobe.com/')" style="cursor: pointer; color: rgb(98, 136, 216);">MALL</span></p>
                </div>
                <!--  地球上的提示条  -->
                <div class="tooltip-right">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-inner"></div>
                </div>
                <HomeGlobeToolBar></HomeGlobeToolBar>
                <SplitScreen></SplitScreen>
                <RollerShade></RollerShade>
                <OrderItemDetail></OrderItemDetail>
                <DeliveryItemDetail></DeliveryItemDetail>
                <div v-if="bigCustomerMenu" class="big-customer-outer" @mouseenter="bigCustomerMenu=true" @mouseleave="bigCustomerMenu=false">
                    <div style="width: 630px;height: 415px;">
                        <div class="handbook-label">
                            我们为您提供了大客户专属的对象存储服务（Object Storage Service，OBS），保障数据的海量、安全、高可靠存储。操作步骤如下：
                        </div>
                        <div class="handbook-label">1、下载并安装OBS Browser+工具；</div>
                        <div style="display: flex;margin-left: 16px;height: 18px;">
                            <a
                                    class="handbook-download-item"
                                    :style="{color: aHover==='1'? '#4C9DF2': '#8C8C8C'}" @mouseenter="aHover='1'" @mouseleave="aHover=''"
                                    href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win32/OBSBrowserPlus-HEC-win32.zip"
                            >windows32位下载</a>|
                            <a
                                    class="handbook-download-item"
                                    :style="{color: aHover==='2'? '#4C9DF2': '#8C8C8C'}" @mouseenter="aHover='2'" @mouseleave="aHover=''"
                                    href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/win64/OBSBrowserPlus-HEC-win64.zip"
                            >windows64位下载</a>|
                            <a
                                    class="handbook-download-item"
                                    :style="{color: aHover==='3'? '#4C9DF2': '#8C8C8C'}" @mouseenter="aHover='3'" @mouseleave="aHover=''"
                                    href="https://obs-community.obs.cn-north-1.myhuaweicloud.com/obsbrowserplus/mac/OBSBrowserPlus-HEC-mac64.zip"
                            >mac版本下载</a>
                        </div>
                        <div class="handbook-label">
                            <span>2、在OBS Browser+登录页选择授权码登录，复制以下授权码；</span>
                            <div
                                    style="float: right;color: #4C9DF2;cursor: pointer;"
                                    v-clipboard:copy="$store.state.user.authorizationCode" v-clipboard:success="copySuccess" v-clipboard:error="copyError"
                            >点击复制授权码</div>
                        </div>
                        <div class="handbook-auth-code scrollbar"><div class="handbook-auth-code-ellipsis">{{ $store.state.user.authorizationCode }}</div></div>
                        <div class="handbook-label">3、您的专属提取码为<span style="color: #8C8C8C;">{{ $store.state.user.obsKey }}</span>；</div>
                        <div class="handbook-label">
                            4、点击登录后，进入您的专属存储目录，可根据本订单ID 搜索对应的交付文件夹；
                        </div>
                        <div class="handbook-label" style="margin-bottom: 0px;">5、选择所需数据进行下载。</div>
                    </div>
                </div>
            </div>
        </div>
        <Overlay :imageWidth="imageWidth"></Overlay>
    </v-card>
</template>
<script>
    import Sidebar from "../components/bars/Sidebar";
    import cesiumView from "../components/main/CesiumView";
    import HomeGlobeToolBar from "../components/main/HomeGlobeToolBar";
    import SplitScreen from "../components/main/SplitScreen";
    import RollerShade from "../components/main/RollerShade";
    import OrderItemDetail from "../components/main/OrderItemDetail";
    import DeliveryItemDetail from "../components/main/DeliveryItemDetail";
    import Overlay from "./Overlay";

    export default {
        name: "Home",
        components: {
            Overlay,
            DeliveryItemDetail,
            Sidebar,
            cesiumView,
            HomeGlobeToolBar,
            SplitScreen,
            RollerShade,
            OrderItemDetail,
        },
        data(){
            return {
                tipNotAgainShow:false,
                imageWidth: 100,
                snackbar: false,
                snackbarInfo: "",
                snackbarColor: "",
                aHover: "",
                bigCustomerMenu: false,
                windowSize: {x: 0, y: 0,},
                scrollTop:0,
            }
        },
        methods: {

            dialogTipClose(){
                this. $store.state.user.dialogTip = false
                if(this.tipNotAgainShow==true)
                {
                    let param = new FormData()  // 创建form对象
                    param.append('noticeFlag', 0)  // 通过append向form对象添加数据
                    this.axios.post('/loginapi/updateNoticeFlag', param)
                        .then(resp => {

                        })
                        .catch(function (error) {
                            alert(error)
                        })
                }
            },
            handleScroll() {
                this.scrollTop=document.documentElement.scrollTop;
            },
            onResize () {
                this.imageWidth = window.innerWidth <= window.innerHeight? window.innerWidth: window.innerHeight;
                this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            },
            logout(){
                this.axios.get('/loginapi/logout', {
                    headers: {
                        'Authorization': localStorage.getItem('token'),
                        'LoginToken': localStorage.getItem('loginToken')
                    }
                }).then(res => {
                    if (res.data.data === "logout successfully") {
                        localStorage.removeItem('userId');
                        localStorage.removeItem('dept');
                        localStorage.removeItem('userName');
                        localStorage.removeItem('loginToken');
                        localStorage.removeItem('role');
                        localStorage.removeItem('token');
                        this.$store.state.user.userId = '';
                        this.$store.state.user.logined = false;
                        this.$router.push("/")
                    } else {
                        console.log(res.data)
                    }
                }).catch(() => {
                    localStorage.removeItem('userId');
                    localStorage.removeItem('dept');
                    localStorage.removeItem('userName');
                    localStorage.removeItem('loginToken');
                    localStorage.removeItem('role');
                    localStorage.removeItem('token');
                    this.$store.state.user.userId = '';
                    this.$store.state.user.logined = false;
                    this.$router.push("/")
                })
            },
            copySuccess() {
                console.log("success")
                this.snackbarColor="success"
                this.snackbarInfo = "已复制到剪切板"
                this.snackbar = true;
            },
            copyError() {
                this.snackbarColor="error"
                this.snackbarInfo = "复制失败"
                this.snackbar = true;
            },
        },
        mounted () {
            this.onResize()
            window.addEventListener('scroll', this.handleScroll);

            // if(localStorage.getItem('pwd') === 'false' && localStorage.getItem('dept') !== '000100'){
            //   this.$store.state.changePassword = true
            //   this.$store.state.persistent = true
            // }

        }
    };
</script>
<style>
    .mainArea {
        width: calc(100% - 430px);
        height: 100%;
        float: right;
    }
    .globeArea {
        position: relative;
        width: 100%;
        height: calc(100% - 49px);
    }
    .bottom-bar {
        position: absolute;
        bottom: 0;
        right: 0;
        display: flex;
        color: white;
        font-size: 0.72rem;
    }
    .bottom-bar p {
        margin-right: 0.06rem;
    }
    .tooltip-arrow {
        position: absolute;
        width: 0;
        height: 0;
    }
    .tooltip-right {
        position: absolute;
        margin-top: -20px;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-right: 5px solid #000000;
    }
    .tooltip-inner {
        padding: 3px 8px;
        background-color: #000000;
        color: white;
        text-align: center;
        max-width: 200px;
        font-size: 11px;
        line-height: 13px;
        text-decoration: none;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .navigation {
        position: relative;
        height: 49px;
        width: 100%;
        display: flex;
        background-color: #212D31;
    }
    .text-none {
        margin-top: 12px;
        margin-right: 20px;
    }
    .modify-list.v-list {
        padding: 4px;
    }
    .modify-list .v-list-item--dense, .v-list--dense .v-list-item {
        min-height: 35px;
    }
    .big-customer-outer {
        position: absolute;
        top: 0px;
        right: 100px;
        padding: 6px 30px 20px 30px;
        background-color: white;
    }
    .handbook-label {
        font-size: 12px;
        color: #101010;
        margin: 14px 8px;
    }
    .handbook-download-item {
        font-size: 12px;
        margin: 0px 12px;
        padding: 1px 0px;
        text-decoration: none;
    }
    .handbook-download-item:hover {
        text-decoration: underline;
    }
    .handbook-auth-code {
        padding: 8px 10px;
        margin: 0px 8px;
        height: 176px;
        line-height: 20px;
        border-radius: 3px;
        border: 1px solid #BBBBBB;
        font-size: 10px;
        color: #8C8C8C;
    }
    .handbook-auth-code-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
    .mongolia{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
</style>
